import { api } from "@/lib/api";

export const quotationsApi = {
  meta: () => api.get("/quotations/meta").then((r) => r.data),
  stats: () => api.get("/quotations/stats").then((r) => r.data),
  list: (params) => api.get("/quotations", { params }).then((r) => r.data),
  get: (id) => api.get(`/quotations/${id}`).then((r) => r.data),
  create: (body) => api.post("/quotations", body).then((r) => r.data),
  update: (id, body) => api.put(`/quotations/${id}`, body).then((r) => r.data),
  setStatus: (id, status, note) => api.patch(`/quotations/${id}/status`, { status, note }).then((r) => r.data),
};

export const QUOTE_STATUS_STYLE = {
  Draft: "bg-slate-100 text-slate-700",
  Sent: "bg-blue-50 text-blue-700 border border-blue-200",
  "Customer Review": "bg-amber-50 text-amber-700 border border-amber-200",
  Accepted: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Rejected: "bg-rose-50 text-rose-700 border border-rose-200",
  Expired: "bg-slate-200 text-slate-500",
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
